import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  useTheme,
  Fab,
  Stack,
  Icon,
  Paper,
  Divider,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { RemMensaje } from "../../redux/actions/mensajes";
import { getCargando, getMensaje, getAnticipos } from "../../redux/selectors";
import { format as DateFormat } from "date-fns";
import { GetAnticipos, Solicitar } from "../../redux/actions/anticipos";
import SolicitarAnticipos from "./solicitarAnticipos";

const Anticipos = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const paramIng = useParams();

  const [color, setColor] = React.useState({
    main: theme.palette.background.default,
    selected: "lightgray",
    pText: theme.palette.text.primary,
    sText: theme.palette.text.secondary,
    pText2: theme.palette.text.primary,
    sText2: theme.palette.text.secondary,
  });
  const { enqueueSnackbar /*, closeSnackbar*/ } = useSnackbar();
  const backdrop = useSelector((state) => getCargando(state));
  const mensaje = useSelector((state) => getMensaje(state));
  const listado = useSelector((state) => getAnticipos(state));

  const [params, setParams] = React.useState(null);
  const [openSol, setOpenSol] = React.useState(false);

  React.useEffect(() => {
    if (mensaje.mensaje !== "") {
      enqueueSnackbar(mensaje.mensaje, {
        preventDuplicate: true,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: mensaje.variant,
        autoHideDuration: 3000,
      });
      dispatch(RemMensaje());
    }
  }, [mensaje]);

  React.useEffect(() => {
    if (paramIng.modo && paramIng.modo === "1") {
      document.body.style.backgroundColor = "#2f3035";
      setColor({
        main: "#2f3035",
        pText: "white",
        sText: "#ACACAC",
        selected: "black",
        pText2: color.pText,
        sText2: color.sText,
      });
    }
    const p = {
      Conductor: paramIng.conductor,
      Modo: paramIng.modo,
      Token: paramIng.token,
    };
    setParams(p);
    dispatch(GetAnticipos(p));
  }, []);

  return (
    <>
      <Stack
        sx={{
          p: 0,
          overflowY: "hidden",
          height: "100vh",
          maxHeight: "100vh",
        }}
      >
        <Backdrop
          sx={{
            zIndex: theme.zIndex.drawer + 1,
          }}
          open={backdrop}
        >
          <CircularProgress />
        </Backdrop>
        {!backdrop && (
          <Stack>
            <Typography
              variant="caption"
              sx={{ p: 1, mb: 1, color: color.sText }}
            >
              Recuerde el cierre semanal es el miércoles 13:00 hs.
              <br />
              Los depósitos se realizan el jueves siguiente.
            </Typography>
            <Divider sx={{ borderColor: color.sText }} />
          </Stack>
        )}
        {!backdrop && listado && listado.length === 0 && (
          <Typography
            sx={{
              mt: 4,
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
            }}
            color="error"
          >
            No hay datos a mostrar.
          </Typography>
        )}

        {!backdrop && listado && listado.length > 0 && (
          <Stack
            sx={{
              overflow: "auto",
              height: "calc(100vh - 80px)",
              mt: 2,
            }}
          >
            <Stack spacing={2}>
              {listado.map((s) => (
                <Paper
                  sx={{
                    p: 1,
                    backgroundColor:
                      s.Estado === 1
                        ? "lightgreen"
                        : s.Estado === 2 || s.Estado === 3
                          ? "#e37a7c"
                          : color.main,
                    border: "1px solid " + color.sText,
                  }}
                >
                  <Stack direction="row">
                    <Icon
                      sx={{
                        ml: 0.5,
                        mr: 2,
                        color:
                          s.Estado === 1 || s.Estado === 2
                            ? color.pText2
                            : color.pText,
                      }}
                      fontSize="large"
                    >
                      monetization_on
                    </Icon>
                    <Stack sx={{ flexGrow: 1 }}>
                      <Typography
                        variant="caption"
                        sx={{
                          color:
                            s.Estado === 1 || s.Estado === 2
                              ? color.sText2
                              : color.sText,
                          flexGrow: 1,
                        }}
                      >
                        {DateFormat(new Date(s.Fecha), "dd/MM/yyyy HH:00")}
                      </Typography>

                      <Typography
                        variant="caption"
                        sx={{
                          lineBreak: "nowrap",
                          color:
                            s.Estado === 1 || s.Estado === 2
                              ? color.sText2
                              : color.sText,
                        }}
                      >
                        {s.Motivo}
                      </Typography>
                    </Stack>
                  </Stack>
                </Paper>
              ))}
            </Stack>
          </Stack>
        )}
      </Stack>

      {!backdrop && (
        <Grid
          container
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            zIndex: 1002,
            margin: "5px",
          }}
          spacing={1}
        >
          <Grid size={12} sx={{ justifyContent: "end", display: "flex" }}>
            <Fab
              size="small"
              color="primary"
              // sx={{ borderRadius: "15px" }}
              onClick={() => setOpenSol(true)}
            >
              <Icon>add</Icon>
            </Fab>
          </Grid>
          <Grid size={12} sx={{ height: "40px" }} />
        </Grid>
      )}

      <SolicitarAnticipos
        open={openSol || false}
        onClose={() => setOpenSol(false)}
        onSave={(v) => {
          dispatch(
            Solicitar({
              Conductor: params.Conductor,
              Motivo: v.motivo,
              Token: params.Token,
            }),
          );
          setOpenSol(false);
        }}
      />
    </>
  );
};

export default Anticipos;
